import isPlainObject from 'lodash/isPlainObject';
import type { MenuPosition } from 'react-select';

export interface SelectOption {
    label: string;
    value: PrimitiveValue;
    isDisabled?: boolean;
    isHtml?: boolean;
}

export const convertToOptions = (arr: Array<any>) => arr.map((value) => ({ label: String(value), value }));

export const getValue = (option: SelectOption | PrimitiveValue): any =>
    isPlainObject(option) ? (option as SelectOption)?.value : option;

export type TView = 'transparent' | 'default';

export interface SelectProps<T = SelectOption> {
    id?: string;
    value?: PrimitiveValue | T;
    defaultValue?: PrimitiveValue | T;
    options?: Array<T>;
    placeholder?: string;
    disabled?: boolean;
    isOpen?: boolean;
    searchable?: boolean;
    clearable?: boolean;
    className?: string;
    classNames?: {
        control?: string;
        option?: string;
        placeholder?: string;
    };
    view?: TView;
    styles?: CSSProperties;
    menuPosition?: MenuPosition;
    stretchMenuToLongestOption?: boolean; // Чтобы растянуть выпадающий список на ширину самой длинной опции
    onChange?(value: PrimitiveValue, option?: T): void;
    instanceId?: string;
}

export interface MultiSelectProps<T = SelectOption>
    extends Omit<SelectProps<T>, 'value' | 'defaultValue' | 'onChange'> {
    value?: Array<PrimitiveValue | T>;
    defaultValue?: Array<PrimitiveValue | T>;
    onChange?(value: Array<T>): void;
    max?: number;
}
